import { AssistantPlugin, AssistantOptions } from '@absis/core-plugins';
declare const window: any;
/**
 * Assistant plugin
 *
 */
export const CBAssistant: AssistantPlugin = {
  open: async (opts: AssistantOptions): Promise<void> => {
    const channelObject =
      opts &&
      opts.getEnvConfig &&
      opts.PROTOCOL &&
      opts.HOSTNAME &&
      opts!.getEnvConfig(opts!.PROTOCOL + '//' + opts!.HOSTNAME);
    const channel = channelObject ? channelObject.channel : 'No channel';
    const target = document.body.querySelector('div[data-app-id]');
    const finalParams = { ...(opts.params ? opts.params : {}), newTab: 'OFI' };
    try {
      switch (channel) {
        case opts.CB_CHANNELS.LO:
          //NOW open virtual assistant from chatbotIframe
          window.top.chatbotIframe.chatbotInterno.load();
          break;
        case opts.CB_CHANNELS.CO:
          //COF navigate to "Consultas Generales" of virtual assistant from PEA
          opts.navigateToPEA(opts.ASSISTANT_PEA_UTILITY, finalParams, target);
          break;
      }
      return Promise.resolve();
    } catch (error) {
      throw new Error(`Unable to obtain assistant in ${channel}: ${error}`);
    }
  },
};
